module.exports = __webpack_public_path__ + "static/media/niriliyapc.ac84b35f.png";